import { Controller } from '@hotwired/stimulus'

// Toggles a password field between hidden/visible for the "Show/Hide" control
// on the Devise auth screens. Survives Turbo Drive navigation (Stimulus-managed).
export default class extends Controller {
  static targets = ['input', 'label']

  toggle() {
    const reveal = this.inputTarget.type === 'password'
    this.inputTarget.type = reveal ? 'text' : 'password'
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = reveal ? 'Hide' : 'Show'
    }
  }
}
